import React from 'react'
import { Typography, Button } from 'antd'
import { 
  GiftOutlined, 
  CheckCircleFilled, 
  SyncOutlined, 
  ThunderboltOutlined, 
  MessageOutlined,
  ArrowRightOutlined
} from '@ant-design/icons'

import IntlMessages from '../../../../util/IntlMessages'

const { Title, Paragraph } = Typography

interface WelcomeStepProps {
  onNext: () => void
}

export const WelcomeStep: React.FC<WelcomeStepProps> = ({ onNext }) => {
  return (
    <div className="step-content-welcome">
      <Title level={2} className="welcome-title">
        <IntlMessages id="onboarding.adp.welcome.title" />
      </Title>
      <Paragraph className="welcome-description">
        <IntlMessages id="onboarding.adp.welcome.description" />
      </Paragraph>
      
      <div className="features-list">
        <div className="feature-item">
          <GiftOutlined className="feature-icon gift-icon" />
          <div className="feature-content">
            <div className="feature-title">
              <IntlMessages id="onboarding.adp.welcome.features.freeTrial.title" />
            </div>
            <div className="feature-description">
              <IntlMessages id="onboarding.adp.welcome.features.freeTrial.description" />
            </div>
          </div>
        </div>
        
        <div className="feature-item">
          <CheckCircleFilled className="feature-icon check-icon" />
          <div className="feature-content">
            <div className="feature-title">
              <IntlMessages id="onboarding.adp.welcome.features.partnership.title" />
            </div>
            <div className="feature-description">
              <IntlMessages id="onboarding.adp.welcome.features.partnership.description" />
            </div>
          </div>
        </div>
        
        <div className="feature-item">
          <SyncOutlined className="feature-icon sync-icon" />
          <div className="feature-content">
            <div className="feature-title">
              <IntlMessages id="onboarding.adp.welcome.features.sync.title" />
            </div>
            <div className="feature-description">
              <IntlMessages id="onboarding.adp.welcome.features.sync.description" />
            </div>
          </div>
        </div>
        
        <div className="feature-item">
          <ThunderboltOutlined className="feature-icon thunder-icon" />
          <div className="feature-content">
            <div className="feature-title">
              <IntlMessages id="onboarding.adp.welcome.features.setup.title" />
            </div>
            <div className="feature-description">
              <IntlMessages id="onboarding.adp.welcome.features.setup.description" />
            </div>
          </div>
        </div>
        
        <div className="feature-item">
          <MessageOutlined className="feature-icon message-icon" />
          <div className="feature-content">
            <div className="feature-title">
              <IntlMessages id="onboarding.adp.welcome.features.support.title" />
            </div>
            <div className="feature-description">
              <IntlMessages id="onboarding.adp.welcome.features.support.description" />
            </div>
          </div>
        </div>
      </div>
      
      <Button 
        type="primary" 
        size="large" 
        onClick={onNext}
        className="get-started-button"
      >
        <IntlMessages id="onboarding.adp.welcome.getStartedButton" /> <ArrowRightOutlined />
      </Button>
    </div>
  )
}
